import React from 'react';
import { Link } from 'react-router-dom';
import { 
  PhoneIcon,
  EnvelopeIcon,
  ClockIcon,
  DocumentArrowDownIcon,
  AcademicCapIcon,
  ChartBarIcon
} from '@heroicons/react/24/outline';
import { useTheme } from '../contexts/ThemeContext';
import TranslatableText from './TranslatableText';

const TopBar = () => {
  const { isDark } = useTheme();

  return (
    <div className={`${isDark ? 'bg-dark-surface border-dark-border' : 'bg-gradient-to-r from-blue-800 to-indigo-800'} text-white text-sm border-b`}>
      <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
        <div className="flex justify-between items-center h-10">
          {/* Left side - Contact Info */}
          <div className="flex items-center space-x-2 sm:space-x-4 lg:space-x-6 flex-1 min-w-0">
            <div className="flex items-center space-x-1">
              <PhoneIcon className="w-3 h-3 flex-shrink-0" />
              <span className="truncate text-xs sm:text-sm">+91-9255429697</span>
            </div>
            <div className="hidden sm:flex items-center space-x-1">
              <EnvelopeIcon className="w-3 h-3 flex-shrink-0" />
              <span className="truncate text-xs lg:text-sm">pmshriggsssfarmana@gmail.com</span>
            </div>
            <div className="hidden lg:flex items-center space-x-1">
              <ClockIcon className="w-3 h-3 flex-shrink-0" />
              <span className="text-sm">
                <TranslatableText text="Mon-Sat: 8:00 AM - 2:30 PM" />
              </span>
            </div>
          </div>

          {/* Right side - Quick Links */}
          <div className="flex items-center space-x-2 sm:space-x-3 lg:space-x-4 flex-shrink-0">
            <Link 
              to="/admissions" 
              className="hidden lg:flex items-center space-x-1 hover:text-cyan-300 transition-colors"
            >
              <AcademicCapIcon className="w-3 h-3" />
              <span><TranslatableText text="Online Admission" /></span>
            </Link>
            <Link 
              to="/downloads" 
              className="hidden md:flex items-center space-x-1 hover:text-cyan-300 transition-colors"
            >
              <DocumentArrowDownIcon className="w-3 h-3" />
              <span><TranslatableText text="Downloads" /></span>
            </Link>
            <Link 
              to="/results" 
              className="hidden lg:flex items-center space-x-1 hover:text-cyan-300 transition-colors"
            >
              <ChartBarIcon className="w-3 h-3" />
              <span><TranslatableText text="Results" /></span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;